import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import RecruitmentBanner from "./recruitment-banner";
import RecruitmentInfo from "./recruitment-software-info";
function AICustomerSupport() {
  return (
    <>
      <Header />
      <main>
        <RecruitmentBanner />
        <RecruitmentInfo />
      </main>
      <Footer />
    </>
  );
}

export default AICustomerSupport;
